import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Customer_Report_Filter from "./customer_report_filter/Customer_Report_Filter";
import Customer_Report_Table from "./customer_report_table/Customer_Report_Table";

const Customer_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Customer Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Customer_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Customer_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Customer Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Customer_Report;
